// Centraliza la lógica de versionado de caché en el cliente.
// Borra caches locales cuando cambia la versión de la app.
// Si no se define REACT_APP_VERSION, usamos el hash de commit de Vercel o "dev".
export const APP_VERSION =
  process.env.REACT_APP_VERSION ||
  process.env.VERCEL_GIT_COMMIT_SHA ||
  'dev';

export function ensureFreshCaches() {
  if (typeof window === 'undefined') return;
  try {
    const stored = localStorage.getItem('app_version') || '';
    if (stored === APP_VERSION) return;

    const prefixes = [
      'salesReport:',
      'products_cache_',
      'products_full_ts', // flag de catálogo completo
      'entradas:list:',
      'valenpos_cart',
    ];

    Object.keys(localStorage).forEach((key) => {
      if (prefixes.some((p) => key.startsWith(p))) {
        localStorage.removeItem(key);
      }
    });

    localStorage.setItem('app_version', APP_VERSION);
  } catch {
    // Silenciar errores de acceso a localStorage (modo incógnito, etc.)
  }
}
